<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js';

export default {
  mixins: [fandomBasicMixin],
  data: function () {
    return { };
  }
};
</script>

<template>
  <div v-easyadmin="easyadminId" :class="contentType" v-if="isContentVisibleToUser()" class="position-relative" page-blank-component>
    <div class="container px-0" v-if="content.breadcrumb">
      <div class="row mx-sm-0">
        <div class="px-sm-0 col-12 d-flex flex-wrap">
          <h1 class="px-3 px-sm-0 mb-3 mx-2 title">{{content.title}}</h1>
        </div>
      </div>
      <breadcrumb class="px-2 pt-0"></breadcrumb>
    </div>
    <component :is="stripe.layout" :content="stripe" v-for="stripe in content.stripes" :key="stripe.$id" :opt-container-content="containerContent"></component>
  </div>
</template>

<style lang="scss">
  [breadcrumb-component] {
    ol {
      background-color: transparent;
    }

    @include media-breakpoint-up(sm) {
      .breadcrumb {
        padding: 0 !important;
      }
    }
  }
</style>

<style lang="scss" scoped>
.title {
  color: $black;
  line-height: 1.08;
  font-size: 1.625rem;
  font-family: $bressay-font;
}
</style>
